import React from "react";
import moment from "moment";
import { DOMAIN } from "../../Config";

function FeedCard({
  detailed,
  feedLink,
  type,
  media = [],
  feedId,
  approved,
  archived,
  deleted,
  date,
  feedMessage,
  headline,
  views,
  location,
  members = [],
  recognitions = [],
  onClick,
  userId, ...props }) {

  const recognitionList = Array.isArray(recognitions) ? recognitions.filter(Boolean) : [];
  const recognizedCount = recognitionList.length;
  const recognitionBadgeTitle = recognitionList[0]?.title || 'Recognition';
  const primaryMedia = Array.isArray(media) && media.length > 0 ? media[0] : null;
  const getImageUrl = (rawPath) => {
    if (!rawPath) return '';

    if (/^https?:\/\//i.test(rawPath)) {
      return rawPath;
    }

    if (rawPath.startsWith('/uploads') || rawPath.startsWith('/upload') || rawPath.startsWith('/api/')) {
      return `${DOMAIN}${rawPath}`;
    }

    if (rawPath.startsWith('uploads/') || rawPath.startsWith('upload/')) {
      return `${DOMAIN}/${rawPath}`;
    }

    return `${DOMAIN}/uploads/${rawPath}`;
  };

  const imagePath = getImageUrl(primaryMedia?.path || '');
  const formattedDate = date ? moment(date, 'DD/MM/YYYY').format('LL') : '';

  return (
    <div className={`${type === 'sm' ? 'w-1/6' : 'w-full'} project-card`} onClick={onClick}>
      <div className={`overflow-hidden rounded-2xl border border-white/10 bg-slate-950/95 backdrop-blur-sm shadow-xl ${detailed ? '' : 'hover:-translate-y-1 hover:shadow-2xl transition-all duration-300'}`}>
        <div className={`flex flex-col ${detailed ? 'md:flex-row-reverse' : ''}`}>
          {imagePath && (
            <div className={`${detailed ? 'md:w-[45%]' : 'w-full'} shrink-0 relative`}>
              {recognizedCount > 0 && (
                <div
                  className="absolute right-0 top-4 z-10 max-w-[75%] px-4 py-1.5 text-xs font-semibold text-white shadow-lg"
                  style={{
                    backgroundColor: '#EF5B0C',
                    clipPath: 'polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px)',
                    borderTopLeftRadius: '6px',
                    borderBottomLeftRadius: '6px'
                  }}
                >
                  {recognitionBadgeTitle}
                </div>
              )}
              <img
                src={imagePath}
                alt="Activity"
                className="w-full h-56 md:h-full object-cover object-top"
              />
            </div>
          )}

          <div className={`p-4 md:p-6 ${detailed ? 'md:w-[55%]' : 'w-full'}`}>
            {!detailed && (
              <>
                <h1 className="text-xl md:text-2xl font-semibold leading-tight mb-2 text-slate-100">{headline}</h1>
                <p className="text-sm text-slate-300 mb-3">
                  <span className="mainText">{formattedDate}</span>
                </p>
              </>
            )}

            {detailed && (
              <>
                <h2 className="text-xl md:text-2xl font-semibold leading-tight mb-2 text-slate-100">{headline}</h2>
                <p className="text-sm text-slate-300 mb-4">
                  <span className="mainText">{formattedDate}</span>
                </p>
              </>
            )}

            <p className="text-[15px] leading-7 mb-3 text-slate-100" style={{ textAlign: "justify", color: '#e5e7eb' }}>
              <span>{feedMessage}</span>
            </p>

            <div className="mt-2 flex flex-wrap items-center gap-4">
              {Number(views) > 0 && (
                <p className="text-slate-200" style={{ textAlign: "justify", color: '#cbd5e1' }}>
                  Views : <span className="mainText">{views}</span>
                </p>
              )}
            </div>

            {detailed && recognizedCount > 0 && (
              <div className="mt-5">
                <h3 className="text-lg font-semibold mainText">Recognized Members</h3>
                <p className="text-sm mb-3 text-slate-300">Members who did something new and received recognition/certificate.</p>
                <div className="space-y-3">
                  {recognitionList.map((item, index) => (
                    <div key={`${item.memberName || 'recognition'}-${index}`} className="p-3 rounded-lg bg-slate-800/80 border border-white/10">
                      <p>
                        <span className="mainText">{item.memberName || 'Member'}</span>
                      </p>
                      {item.title && (
                        <p>
                          Achievement : <span className="mainText">{item.title}</span>
                        </p>
                      )}
                      {item.certificateType && (
                        <p>
                          Type : <span className="mainText">{item.certificateType}</span>
                        </p>
                      )}
                      {item.certificateIssuedOn && (
                        <p>
                          Date : <span className="mainText">{item.certificateIssuedOn}</span>
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default FeedCard;
